<template>
  <div>
    <full-calendar id="calendario_citas_sipsic" :events="eventosFullCalendar" :config="configuracionFullCalendar" ref="calendar" @event-selected="calendarioEventoClic"></full-calendar>
    <input type="button" @click="insertarIcono" class="form-control" />
  </div>
  
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';
  import store from '@/store/index'
  import FullCalendar from '@/../static/js/fullcalendar'

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        eventosFullCalendar: [],
        configuracionFullCalendar: {
          slotLabelFormat: 'hh:mma',
          header: {
            left: 'prev,today,next',
            center: 'title',
            right: 'month,agendaWeek,agendaDay'
          },
          defaultView: 'agendaWeek',
          editable: false,
          businessHours: {
            daysOfWeek: [1, 2, 3, 4, 5, 6 , 7], // Monday - Friday
            start: '08:00:00', // a start time (10am in this example)  parametros.horarioAtencionInicio
            end: '16:00:00', // an end time (6pm in this example) parametros.horarioAtencionFinal
          },
          defaultDate: moment().add(1, 'days').format('YYYY-MM-DD'),
          selectConstraint: "businessHours",
          weekends: false,
          minTime: '08:00',
          maxTime: '16:00',
          allDaySlot: false,
          defaultTimedEventDuration: '00:15:00',
          slotDuration: '00:15:00',
          slotLabelInterval: "01:00",
          selectable: false,
          height: 1000,
          contentHeight: 'auto'

        },
        idDelModelo: null
      }
    },
    props: {
      parametros: Object
    },
    mounted() {
      //console.log(this.parametros)      
      this.obtenerCitasAgenda();
      //this.$store.dispatch("A_SIPSIC_Catalogo_Establecer003Psicologo", parametros);
    },
    components: {
      FullCalendar
    },
    methods: {
      obtenerCitasAgenda: function () {
        var peticion = {
          "esPrueba": false,
          "filtrarPorPsicologo": this.parametros.FiltrarPorPsicologo
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SIPSIC.funciones.GetBloquesAgenda, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {
            //console.log(response)
            this.eventosFullCalendar = response.data.AgendaEventosBloques;
            //this.insertarIcono();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      calendarioEventoClic: function (event, jsEvent, view) {
        //console.log(event)
        this.cambiarDatos(event);

      },
      cambiarDatos(evento) {

        //this.$store.dispatch("A_SIPSIC_Catalogo_Establecer003Psicologo", parametros);
        //console.log("Enviando")
        //console.log(evento)
        this.$emit("valorParaElPadreCalendarioDeCitas", evento);

        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      },
      insertarIcono: function () {
        //console.log('paco');
        $(".fc-title").each(function (index, element) {
          var titulo = element.innerHTML;
          var res = titulo.replace("(Sala Lúdica)", "<i class='fa fa-couch'></i>");
          console.log(res);
          element.innerHTML = res;
        });
      }
    },
    created() {
      if(this.parametros.fechaInicial){
        this.configuracionFullCalendar.defaultDate = this.parametros.fechaInicial;
      }
    }
  }
</script>

<style scoped>


  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  .new-row {
    margin-top: 20px;
  }

  .padding-div-low {
    padding-top: 40px;
  }

  .alinear_izq {
    float: left;
  }

  .alinear_der {
    float: right;
  }

  .contenedor-puntero {
    background: #212529;
    border-radius: 2px;
    padding: 10px;
    border: 1px solid white;
    margin-bottom: 1.5em;
  }
</style>
<style>
  .padding-div-low {
    padding-top: 40px;
  }

  #calendario_citas_sipsic .fc-view-container {
    background-color: transparent !important;
    color: #343a40 !important;
    border-color: #212529 !important;
  }

  #calendario_citas_sipsic .fc-view table {
    border-color: #212529 !important;
  }

  #calendario_citas_sipsic .fc-axis {
    background-color: #504f54;
    color: white !important;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
  }

  #calendario_citas_sipsic .fc-day-header {
    background-color: #212529 !important;
    color: white !important;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji" !important;
    padding: .75rem !important;
  }

  #calendario_citas_sipsic .fc-button {
    background-color: whitesmoke !important;
    border: none !important;
    padding: .375rem 1.35rem !important;
    color: #212529 !important;
    text-shadow: none !important;
    display: inline-block !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    font-size: 1rem !important;
    border-radius: .25rem !important;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out !important;
  }

  #calendario_citas_sipsic .fc-state-active {
    background-color: rgb(174, 174, 174) !important;
  }

  #calendario_citas_sipsic .fc-button:focus {
    outline: none !important;
  }

  #calendario_citas_sipsic .fc-today {
    background-color: rgba(242,242,242,0.5) !important;
    color: white !important;
  }

  #calendario_citas_sipsic .fc-day-number {
    color: white !important;
  }

  #calendario_citas_sipsic .fc-event {
    background-color: #212529;
    border-color: #32383e !important;
    color: white !important;
    padding: 0 .375rem !important;
    font-size: 1.0em;
    border-radius: .25rem !important;
    width: 80% !important;
    text-align: center !important;
    margin: auto !important;
  }

  tr {
  }
</style>





// WEBPACK FOOTER //
// src/components/SIPSIC/Dictamenes/ControlDeDictamenes/CalendarioDeCitas.vue